import { FC, useEffect, useState } from "react"
import { useAuth } from "@ncs/ncs-api/contexts"
import { Banner, Icon, Link } from "@ncs/web-legos/components"

export const DiscountBanner: FC = () => {
	const [isBannerVisible, setIsBannerVisible] = useState(true)
	const { initialized, punchOutSessionId } = useAuth()
	const [isShowDate, setIsShowDate] = useState(true)

	useEffect(() => {
		const currentDate = new Date()
		const currentDay = currentDate.getDate()
		const currentMonth = currentDate.getMonth() + 1

		const isDateInRange = currentMonth === 5 && currentDay >= 11 && currentDay <= 15

		setIsShowDate(isDateInRange)
	}, [])

	const showDiscountBanner = initialized && !punchOutSessionId && isBannerVisible && isShowDate

	if (!showDiscountBanner) {
		return null
	}

	return <Banner message={<DiscountBannerMessage />} onClose={() => setIsBannerVisible(false)} />
}

const DiscountBannerMessage: FC = () => (
	<>
		<div>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="22"
				height="20"
				viewBox="0 0 22 20"
				fill="none"
			>
				<path
					d="M19.7681 12.5856L19.5227 13.2944H19.5227L19.7681 12.5856ZM19.7681 6.91437L20.0135 7.6231V7.6231L19.7681 6.91437ZM1.73189 12.5856L1.97727 13.2944H1.97727L1.73189 12.5856ZM1.73189 6.91437L1.48652 7.6231L1.48652 7.6231L1.73189 6.91437ZM14.2803 7.28033C14.5732 6.98744 14.5732 6.51256 14.2803 6.21967C13.9874 5.92678 13.5126 5.92678 13.2197 6.21967L13.75 6.75L14.2803 7.28033ZM7.21967 12.2197C6.92678 12.5126 6.92678 12.9874 7.21967 13.2803C7.51256 13.5732 7.98744 13.5732 8.28033 13.2803L7.75 12.75L7.21967 12.2197ZM4.75 18.75V18C2.95507 18 1.5 16.5449 1.5 14.75H0.75H0C0 17.3734 2.12665 19.5 4.75 19.5V18.75ZM20.75 14.75H20C20 16.5449 18.5449 18 16.75 18V18.75V19.5C19.3734 19.5 21.5 17.3734 21.5 14.75H20.75ZM16.75 0.75V1.5C18.5449 1.5 20 2.95507 20 4.75H20.75H21.5C21.5 2.12665 19.3734 0 16.75 0V0.75ZM4.75 0.75V0C2.12665 0 0 2.12665 0 4.75H0.75H1.5C1.5 2.95507 2.95507 1.5 4.75 1.5V0.75ZM19.7681 12.5856L20.0135 11.8769C19.1315 11.5716 18.5 10.7336 18.5 9.75H17.75H17C17 11.3924 18.0554 12.7863 19.5227 13.2944L19.7681 12.5856ZM17.75 9.75H18.5C18.5 8.76644 19.1315 7.92844 20.0135 7.6231L19.7681 6.91437L19.5227 6.20565C18.0554 6.71367 17 8.10761 17 9.75H17.75ZM3.75 9.75H3C3 10.7336 2.36845 11.5716 1.48652 11.8769L1.73189 12.5856L1.97727 13.2944C3.44461 12.7863 4.5 11.3924 4.5 9.75H3.75ZM1.73189 6.91437L1.48652 7.6231C2.36845 7.92844 3 8.76644 3 9.75H3.75H4.5C4.5 8.10762 3.44462 6.71367 1.97727 6.20565L1.73189 6.91437ZM20.75 5.75H21.5V4.75H20.75H20V5.75H20.75ZM20.75 13.75H20V14.75H20.75H21.5V13.75H20.75ZM0.75 13.75H0V14.75H0.75H1.5V13.75H0.75ZM0.75 5.75H1.5V4.75H0.75H0V5.75H0.75ZM16.75 18.75V18H4.75V18.75V19.5H16.75V18.75ZM16.75 0.75V0H4.75V0.75V1.5H16.75V0.75ZM1.73189 12.5856L1.48652 11.8769C0.807846 12.1119 0 12.7475 0 13.75H0.75H1.5C1.5 13.6941 1.52081 13.6208 1.60172 13.5313C1.6866 13.4373 1.81974 13.3489 1.97727 13.2944L1.73189 12.5856ZM19.7681 6.91437L20.0135 7.6231C20.6922 7.38813 21.5 6.75246 21.5 5.75H20.75H20C20 5.80587 19.9792 5.87917 19.8983 5.96871C19.8134 6.06265 19.6803 6.15111 19.5227 6.20565L19.7681 6.91437ZM1.73189 6.91437L1.97727 6.20565C1.81974 6.15111 1.6866 6.06265 1.60172 5.96871C1.52081 5.87917 1.5 5.80587 1.5 5.75H0.75H0C0 6.75246 0.807846 7.38813 1.48652 7.6231L1.73189 6.91437ZM19.7681 12.5856L19.5227 13.2944C19.6803 13.3489 19.8134 13.4373 19.8983 13.5313C19.9792 13.6208 20 13.6941 20 13.75H20.75H21.5C21.5 12.7475 20.6922 12.1119 20.0135 11.8769L19.7681 12.5856ZM8.75 6.75H8C8 6.88807 7.88807 7 7.75 7V7.75V8.5C8.7165 8.5 9.5 7.7165 9.5 6.75H8.75ZM7.75 7.75V7C7.61193 7 7.5 6.88807 7.5 6.75H6.75H6C6 7.7165 6.7835 8.5 7.75 8.5V7.75ZM6.75 6.75H7.5C7.5 6.61193 7.61193 6.5 7.75 6.5V5.75V5C6.7835 5 6 5.7835 6 6.75H6.75ZM7.75 5.75V6.5C7.88807 6.5 8 6.61193 8 6.75H8.75H9.5C9.5 5.7835 8.7165 5 7.75 5V5.75ZM14.75 12.75H14C14 12.8881 13.8881 13 13.75 13V13.75V14.5C14.7165 14.5 15.5 13.7165 15.5 12.75H14.75ZM13.75 13.75V13C13.6119 13 13.5 12.8881 13.5 12.75H12.75H12C12 13.7165 12.7835 14.5 13.75 14.5V13.75ZM12.75 12.75H13.5C13.5 12.6119 13.6119 12.5 13.75 12.5V11.75V11C12.7835 11 12 11.7835 12 12.75H12.75ZM13.75 11.75V12.5C13.8881 12.5 14 12.6119 14 12.75H14.75H15.5C15.5 11.7835 14.7165 11 13.75 11V11.75ZM13.75 6.75L13.2197 6.21967L7.21967 12.2197L7.75 12.75L8.28033 13.2803L14.2803 7.28033L13.75 6.75Z"
					fill="#FEFEFE"
				/>
			</svg>
			<p>
				Use code <b>ROLL20OFF</b> for up to <b>20% off</b> selected <b>Roller</b> parts.
			</p>
		</div>
		<div>
			{" "}
			<Link
				to="/shop/search?categories=%255B%252249%2522%255D&manufacturer=1000&ordering=%2522title%2522"
				color="white"
			>
				Shop Now <Icon icon="arrow-right" />
			</Link>
		</div>
	</>
)
